export { default } from "./PDFViewer";
export type { PDFViewerProps } from "./PDFViewer";
